import i18n from 'i18next';
import HttpApi from 'i18next-http-backend';
import config from 'utils/config';

import enGB from './en-GB';

import LanguageDetector from 'i18next-browser-languagedetector';

const {locale} = config;

const resources = {
	'en-GB': () => ({default: enGB}),
	'en-US': () => import(/* webpackChunkName: 'en-US' */ './en-US.js'),
	'de-DE': () => import(/* webpackChunkName: 'de-DE' */ './de-DE.js'),
	'de-DE-Sie': () =>
		import(/* webpackChunkName: 'de-DE-Sie' */ './de-DE-Sie.js'),
	'es-ES': () => import(/* webpackChunkName: 'es-ES' */ './es-ES.js'),
	'fr-FR': () => import(/* webpackChunkName: 'fr-FR' */ './fr-FR.js'),
	'nl-NL': () => import(/* webpackChunkName: 'nl-NL' */ './nl-NL.js'),
	'no-NO': () => import(/* webpackChunkName: 'no-NO' */ './no-NO.js'),
	'pt-PT': () => import(/* webpackChunkName: 'pt-PT' */ './pt-PT.js'),
	'sv-SE': () => import(/* webpackChunkName: 'sv-SE' */ './sv-SE.js'),
	'zh-CN': () => import(/* webpackChunkName: 'zh-CN' */ './zh-CN.js'),
	'zh-TW': () => import(/* webpackChunkName: 'zh-TW' */ './zh-TW.js'),
	'ja-JP': () => import(/* webpackChunkName: 'ja-JP' */ './ja-JP.js'),
	'da-DK': () => import(/* webpackChunkName: 'da-DK' */ './da-DK.js'),
	'fi-FI': () => import(/* webpackChunkName: 'fi-FI' */ './fi-FI.js'),
	'hu-HU': () => import(/* webpackChunkName: 'hu-HU' */ './hu-HU.js'),
	'it-IT': () => import(/* webpackChunkName: 'it-IT' */ './it-IT.js'),
	'pl-PL': () => import(/* webpackChunkName: 'pl-PL' */ './pl-PL.js'),
	'ro-RO': () => import(/* webpackChunkName: 'ro-RO' */ './ro-RO.js'),
	'ko-KR': () => import(/* webpackChunkName: 'ko-KR' */ './ko-KR.js'),
	'th-TH': () => import(/* webpackChunkName: 'th-TH' */ './th-TH.js'),
};

// Create short keys, where there is duplicate match:
// the first one will be the last defined (hence Array.reverse())
Object.keys(resources)
	.reverse()
	.forEach(key => {
		const [lang] = key.split('-');
		resources[lang] = resources[key];
	});

// Norwegian, translation issues https://github.com/i18next/i18next/issues/257#issue-36343630
resources.nb = resources['no-NO'];
resources.nn = resources['no-NO'];

// Set the fallback language to the Hub's language, or English
const fallbackLng = [locale, 'en-GB'].filter(Boolean);

i18n.use(LanguageDetector)
	.use(HttpApi)
	.init({
		interpolation: {escapeValue: false},
		react: {
			useSuspense: true,
		},
		fallbackLng,
		detection: {
			order: ['querystring', 'localStorage', 'navigator'],
			lookupQuerystring: 'lang',
		},
		debug: false,
		backend: {
			loadPath: '{{lng}}:{{ns}}',

			request: async (options, url, payload, callback) => {
				const [lang] = url.split(':');

				const resource =
					resources[lang] || resources[lang.substr(0, 2)];

				// Set default
				let data = {};

				// If the resource exists
				if (resource) {
					try {
						const {default: obj} = await resource();

						data = obj;
					} catch {
						// failed to load
					}
				}

				callback(null, {
					status: 200,
					data,
				});
			},
		},
	});

// Set these to the fallback language, en-GB
i18n.addResourceBundle('en-GB', 'translation', enGB);

export default i18n;
